<form [formGroup]="vehicleUseForm">
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <h2
      dsContent
      class="bold-header"
      [contentPath]="'policy.newVehicleUsageMileageHeaderWithoutPrimaryUseOptions'"
    ></h2>

    <div class="add-vehicle-title">
      <div class="row vehicle">
        <div class="flex self-center pad-10">
          <div class="self-center pad-right-30" aria-hidden="true">
            <span class="icon-auto"></span>
          </div>
          <div class="self-center">
            <div class="risk-info">
              <div class="caption" dsContent [contentPath]="'policy.newVehicleCaption'"></div>
              <div class="heading">
                {{ vehicleRiskDescription$ | async }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-top-10">
      <div class="row">
        <div class="column twelve md-six">
          <ds-form-control-container
            labelText="Annual Mileage"
            [control]="vehicleUseForm.controls['mileage']"
          >
            <input
              id="mileage"
              class="fill"
              formControlName="mileage"
              data-cy="addVehicleOdometerInput"
              value="12,000"
            />
            <ds-form-control-message
              [control]="vehicleUseForm.controls['mileage']"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
      </div>
      @if (isOwnership) {
        <div class="row">
          <div class="column twelve md-six">
            <ds-form-control-container
              labelText="Ownership Date"
              [control]="vehicleUseForm.controls['ownershipDate']"
            >
              <select
                id="year"
                class="icon fill"
                formControlName="ownershipDate"
                data-cy="vehiclePrimaryUseSelect"
              >
                <option value="unset" selected disabled>Select a Ownership Date</option>
                @for (ownershipDate of primaryOwnershipDateOptions; track ownershipDate) {
                  <option [value]="ownershipDate">
                    {{ ownershipDate }}
                  </option>
                }
              </select>
              <span class="icon-chevron-down"></span>
              <ds-form-control-message
                [control]="vehicleUseForm.controls['ownershipDate']"
              ></ds-form-control-message>
            </ds-form-control-container>
          </div>
        </div>
      }

      <div class="row pad-top-20">
        <div
          class="column twelve caption"
          dsContent
          [contentPath]="'policy.newVehicleUsageHelpText'"
        ></div>
      </div>
    </div>
  </div>

  <div class="row column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      [displayBackButton]="true"
      [tertiaryButtonName]="'Cancel'"
      [disabled]="vehicleUseForm.invalid"
      primaryButtonName="Continue"
      (primaryEvent)="vehicleUseInfoFormSubmit()"
      (tertiaryEvent)="cancelEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</form>
